import * as React from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, message, Modal } from "antd";
import { useAuth } from "@/component/Auth";
import styled from "styled-components";
import { conference } from "@/api";
import { checkStoredPlayTips } from "../pub";
// import AutoPlayMusic from "../automusic"
import { AnyType, ConferenceInterface, JoinMeetingInterrupt } from "@/types";
import {
  NORMALSETTINGKEY,
  METTINGPAGE_SAVED_MEETING_INFO,
  LOGININFOSTORE,
  LOGINTOKEN
} from "@/config/const";
import prompt from "antd-prompt";
import { notChromeMessage, storage } from "@/util";
import Checkbox from "antd/es/checkbox/Checkbox";

import * as consts from "@/config/const";
import useRtm from "../../../hooks/use-rtm";
import isElectron from "is-electron";
import userIcon from "../../../assets/images/user.svg";

const Container = styled.div`
  align-items: center;
  width: 400px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  .atitle {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--Dark, #0F172A);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    padding-top: 40px;
    padding-bottom: 20px;
  }
  .form {
    width: 280px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .w280 {
    width: 280px;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .join {
    width: 280px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 40px;
  }
  .buttonLogin {
    border-radius: 16px;
    background: var(--Brand-color, #00AEEF);
  }
  .input{
    height: 35px;
    border-radius: 16px;
    border: 1px solid #ECEEF1;
    margin-top: 5px;
  }
  .tag {
    color: #374151;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: -0.12px;
    padding-left: 15px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00AEEF;
    border-color: #00AEEF;
  }
`;

const JoinMeeting: React.FunctionComponent = (props) => {
  const auth = useAuth();
  // const { loggedIn, loginfo, updateLogInfo } = auth;
  const logInfo = storage.get(consts.LOGININFOSTORE);
  // if (logInfo) {
  //     console.log(logInfo.userId)
     
  // }
  const rtm = useRtm({}, (closedByServer)=>{
    console.log("[Login] closedByServer", closedByServer);
    //关闭rtm
    rtm.logout();
    //退出登录
    storage.remove(LOGININFOSTORE);
    storage.remove(LOGINTOKEN);
    if (isElectron()) {
      alert(`Нэвтрэх хуудас руу чиглүүлж байна`);
      history.replace("/");
    } else {
      window.location.href = "/";
    }
    alert("Нэвтрэх оролдлого олон удаа хийгдлээ");
  });

  const history = useHistory();
  const [form] = Form.useForm();

  const settingItem: AnyType = storage.get(NORMALSETTINGKEY) as any;
  const { audio = false, mic = false, video = false } = settingItem;

  const [audioOn, setAudioOn] = React.useState(mic);
  const [videoOn, setVideoOn] = React.useState(video);
  const [simulcastOn, setSimulcastOn] = React.useState(false);
  const [speakerOn, setSpeakerOn] = React.useState(audio);

  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = React.useState(false);
  const [passwordValue, setPasswordValue] = React.useState("");

  const loginfo = storage.get(LOGININFOSTORE);

  const getConferenceInfo = async (
    conferenceNo: string,
    userName: string,
    password?: string
  ) => {
    try {
      const ret = await conference.conferenceJoin(
        {
          conferenceNo,
          userName,
          password,
        },
        {
          "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      //需要先判断ret的code是200还是600xxx
      console.log(`[JoinMeeting] ret=${JSON.stringify(ret)}`);
      const con = ret.conference as ConferenceInterface;
      con.attendList = ret.attendList;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      con.userId = ret.userid;
      return con;
    } catch (e) {
      return e;
    }
  };

  const goMetting = async (conf: ConferenceInterface, userName: string) => {
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `/meeting/${
      conf.roomId
    }?username=${userName}&audio=${!!audioOn}&video=${!!videoOn}&speaker=${!!speakerOn}&simulcast=${!!simulcastOn}`;
    
    history.push(url);
  };

  const join = async () => {
      //检查是否需要播放提示音
       
    const browserErrMsg = notChromeMessage();
    if (browserErrMsg) {
      message.error(browserErrMsg);
      return;
    }
    const values = await form.validateFields();
    const { conferenceNo, userName } = values as AnyType;
    checkStoredPlayTips( conferenceNo);
    const con: any = await getConferenceInfo(conferenceNo, userName);
    //异常情况处理
    if (con.code !== undefined) {
      let code = con.code;
      let data = con.data;
      if (code === JoinMeetingInterrupt.passwordNeeded) {
        //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
        console.log(`[JoinMeeting] password needed`);
        showPasswordInputDialog(true);
        return;
      } else if (code === JoinMeetingInterrupt.wrongPassword) {
        //输入的会议密码不正确
      }
    } else {
      goMetting(con, userName);
    }
  };

  const checkPassword = async () => {
    const password = await prompt({
      title: "会议密码",
      placeholder: "请输入会议密码",
      rules: [
        {
          required: true,
          message: "请输入会议密码",
        },
      ],
      modalProps: {
        width: "400px",
      },
    });
    return password || "";
  };

  const showPasswordInputDialog = (bShow: boolean) => {
    setIsPasswordDialogOpen(bShow);
  };

  const handleShowPasswordInputDialogOk = async () => {
    //获取到password,直接再调用加会接口加入会议
    const values = await form.validateFields();
    const { conferenceNo, userName } = values as AnyType;
    const con: any = await getConferenceInfo(
      conferenceNo,
      userName,
      passwordValue
    );
    //异常情况处理
    if (con.code !== undefined) {
      let code = con.code;
      let data = con.data;
      if (code === JoinMeetingInterrupt.passwordNeeded) {
        //请输入会议密码,弹出会议密码输入框,并验证会议密码是否正确
        console.log(`[JoinMeeting] password needed`);
        //showPasswordInputDialog(true);
        return;
      } else if (code === JoinMeetingInterrupt.wrongPassword) {
        //输入的会议密码不正确
        console.log(`[JoinMeeting] password is wrong`);
      }
    } else {
      goMetting(con, userName);
    }

    setIsPasswordDialogOpen(false);
  };

  const handleShowPasswordInputDialogCancel = () => {
    setIsPasswordDialogOpen(false);
  };

  const passwordValueChange = (e: any) => setPasswordValue(e.target.value);

  return (
    <Container>
      <div className="atitle">Уулзалтад орох</div>
      {/* <AutoPlayMusic /> */}
      <Form form={form} className="form">
        <span className="tag"> Уулзалтын ID </span>
        <Form.Item
          name="conferenceNo"
          label=""
          rules={[{ required: true, message: "Уулзалтын ID оруулна уу" }]}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={userIcon} alt="userIcon" />} placeholder="Уулзалтын ID" />
        </Form.Item>
        <span className="tag"> Хэрэглэгчийн нэр </span>
        <Form.Item
          name="userName"
          label=""
          rules={[{ required: true, message: "Хэрэглэгчийн нэр оруулна уу" }]}
          initialValue={loginfo.realName}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={userIcon} alt="userIcon" />} placeholder="Хэрэглэгчийн нэр оруулна уу" />
        </Form.Item>
      </Form>
      <div className="w280 mt25">
        <Checkbox className="ml10" autoFocus={false}
          checked={speakerOn}
          onChange={(e) => setSpeakerOn(e.target.checked)}
        >
          Спикер
        </Checkbox>
      </div>

      <div className="w280 mt5">
        <Checkbox className="ml10" autoFocus={false}
          checked={audioOn}
          onChange={(e) => setAudioOn(e.target.checked)}
        >
          Микрофон
        </Checkbox>
      </div>

      <div className="w280 mt5">
        <Checkbox className="ml10" autoFocus={false}
          checked={videoOn}
          onChange={(e) => setVideoOn(e.target.checked)}
        >
          Камер
        </Checkbox>
      </div>
      <div className="join mt5">
        <Button type="primary" onClick={join} className="w280 mt5 buttonLogin">
          Уулзалтад орох
        </Button>
      </div>

      <Modal
        title="Нууц үгээ оруулна уу"
        width={300}
        centered
        visible={isPasswordDialogOpen}
        onOk={handleShowPasswordInputDialogOk}
        onCancel={handleShowPasswordInputDialogCancel}
        okText="Орох"
        cancelText="Болих"
      >
        <Input
          value={passwordValue}
          onChange={passwordValueChange}
          placeholder="Уулзалтын нууц үг"
        />
      </Modal>
      {/* <MeetingContext.Provider value={{ participants, service }}>
        <VideoCard participant={me} showTag={false} showTool={false} />
      </MeetingContext.Provider> */}
    </Container>
  );
};

export default JoinMeeting;
